import React from "react"

function Updates() {
	return (
		<div className="main-container">
			<div className="contain">
				<span className="main-title">UPDATES</span>
			</div>
		</div>
	)
}

export default Updates